module.exports = __webpack_public_path__ + "img/spring.914a96c6.png";